import http from "../../helpers/http";

import {
    FETCH_PARTNERS_CONTENT,
    FETCH_PARTNERS_CONTENT_SUCCESS,
    FETCH_PARTNERS_CONTENT_FAILED
} from "./actionTypes";

export const fetchPartners = () => (dispatch) => {
    dispatch({
        type: FETCH_PARTNERS_CONTENT,
        payload: null
    });
    http
        .get("partners-page")
        .then(({ data }) => {
            dispatch({
                type: FETCH_PARTNERS_CONTENT_SUCCESS,
                payload: data
            });
        })
        .catch((error) => {
            dispatch({
                type: FETCH_PARTNERS_CONTENT_FAILED,
                payload: error
            });
        });
};
